"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertFuelToCommunityCreditsRequestBodyToJSON = exports.ConvertFuelToCommunityCreditsRequestBodyFromJSONTyped = exports.ConvertFuelToCommunityCreditsRequestBodyFromJSON = void 0;
function ConvertFuelToCommunityCreditsRequestBodyFromJSON(json) {
    return ConvertFuelToCommunityCreditsRequestBodyFromJSONTyped(json, false);
}
exports.ConvertFuelToCommunityCreditsRequestBodyFromJSON = ConvertFuelToCommunityCreditsRequestBodyFromJSON;
function ConvertFuelToCommunityCreditsRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fuelAmount': json['fuelAmount'],
    };
}
exports.ConvertFuelToCommunityCreditsRequestBodyFromJSONTyped = ConvertFuelToCommunityCreditsRequestBodyFromJSONTyped;
function ConvertFuelToCommunityCreditsRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fuelAmount': value.fuelAmount,
    };
}
exports.ConvertFuelToCommunityCreditsRequestBodyToJSON = ConvertFuelToCommunityCreditsRequestBodyToJSON;
